import gsap from 'gsap'

function initAwardsPopups() {
  const popups = document.querySelectorAll('[data-target="award_popup"]')

  if (popups && popups.length > 0) {
    const slidesWithPopup = document.querySelectorAll(
      '[data-target="has-popup"]'
    )

    if (slidesWithPopup.length > 0) {
      slidesWithPopup.forEach((slide, index) => {
        const popupOverlay = document.querySelectorAll(
          '[data-target="award_overlay"]'
        )
        const popupContent = document.querySelectorAll(
          '[data-target="award_popup-content"]'
        )
        const href = slide.querySelector('a')
        const closeBtn = document.querySelectorAll(
          '[data-target="close-button"]'
        )

        href.addEventListener('click', (e) => {
          e.preventDefault()
        })

        gsap.set(popupOverlay, { autoAlpha: 0 })
        gsap.set(popupContent, { autoAlpha: 0, xPercent: 100 })
        gsap.set(popups, { pointerEvents: 'none' })

        slide.addEventListener('click', (e) => {
          gsap.to(popupOverlay[index], {
            autoAlpha: 1,
            duration: 0.3,
          })
          gsap.to(popupContent[index], {
            autoAlpha: 1,
            xPercent: 0,
            duration: 0.3,
          })
          gsap.set(popups[index], { pointerEvents: 'all' })
          gsap.set(document.body, { overflow: 'hidden' })
          gsap.set(document.documentElement, { overflow: 'hidden' })
        })

        popupOverlay[index].addEventListener(
          'click',
          (e) => {
            gsap.to(popupOverlay[index], {
              autoAlpha: 0,
              duration: 0.3,
            })
            gsap.to(popupContent[index], {
              autoAlpha: 0,
              xPercent: 100,
              duration: 0.3,
            })
            gsap.set(popups, { pointerEvents: 'none' })
            gsap.set(document.body, { overflow: 'auto' })
            gsap.set(document.documentElement, { overflow: 'auto' })
          },
          false
        )

        closeBtn.forEach((btn) => {
          btn.addEventListener(
            'click',
            (e) => {
              gsap.to(popupOverlay[index], {
                autoAlpha: 0,
                duration: 0.3,
              })
              gsap.to(popupContent[index], {
                autoAlpha: 0,
                xPercent: 100,
                duration: 0.3,
              })
              gsap.set(popups, { pointerEvents: 'none' })
              gsap.set(document.body, { overflow: 'auto' })
              gsap.set(document.documentElement, { overflow: 'auto' })
            },
            false
          )
        })
      })
    }
  }
}

export default initAwardsPopups
